export default __webpack_public_path__ + "93057dd3c5413a1bbc326800b91287a4.svg";